// Small mono status-chip pill — colored dot + uppercase label, per the
// design-reference `.chip` pattern (SQ_TeamControl.html §chips). Used for
// the honest state-summary row at the top of the Agent Command page.

import { AGENT_FONT } from './theme'

export interface AgentStatusChipProps {
  label: string
  accent: string
  title?: string
}

export default function AgentStatusChip({ label, accent, title }: AgentStatusChipProps) {
  return (
    <span
      title={title}
      style={{
        fontFamily: AGENT_FONT.mono,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        padding: '4px 10px',
        borderRadius: 6,
        border: `1px solid ${accent}66`,
        background: `${accent}14`,
        color: accent,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        whiteSpace: 'nowrap',
        lineHeight: 1.4,
      }}
    >
      <span aria-hidden="true" style={{ width: 6, height: 6, borderRadius: '50%', background: accent, flexShrink: 0 }} />
      {label}
    </span>
  )
}
